
<agpr-dropdown
    class="agpr-timezonePicker"
    [id]="id + '.timezonePicker.dropdown'"
    [ngClass]="styleClass"
    [disabled]="disabled"
    [options]="timezones"
    [placeholder]="placeholder"
    [(ngModel)]="dropDownOption"
    (ngModelChange)="timeZoneSelected($event.value)"
    ariaLabel="Common.forms.timePicker.timeZoneLabel"
    [label]="label"
>
</agpr-dropdown>
